import {
  SET_VOUCHER_CODE_FIELD,
  SET_VOUCHER_CODE,
  APPLY_VOUCHER_CODE,
  APPLY_VOUCHER_CODE_FAIL,
  CANCEL_VOUCHER_CODE
} from "../actions/voucher";

export default function ticket(state = {
  showVoucherCodeField: false,
  voucherCode: null,
  result: null,
  fail: null,
  minPurchase: null
}, action) {
  switch (action.type) {
    case SET_VOUCHER_CODE_FIELD:
      return {
        ...state,
        showVoucherCodeField: action.payload.item,
      };
    case SET_VOUCHER_CODE:
      return {
        ...state,
        voucherCode: action.payload.item,
        fail: false
      };
    case APPLY_VOUCHER_CODE:
      return {
        ...state,
        result: action.payload.result
      }
    case APPLY_VOUCHER_CODE_FAIL:
      return {
        ...state,
        fail: true,
        minPurchase: action.payload.minPurchase
      }
    case CANCEL_VOUCHER_CODE:
      return {
        ...state,
        showVoucherCodeField: true,
        result: null,
        fail: null
      }

    default:
      return state;
  }
}